<rt-dialog-header [heading]="'rti.werken_in_een_hotel.name' | translate">
  {{ 'rti.werken_in_een_hotel.create_posting.modal.subtitle' | translate }}
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rti-werken-in-een-hotel-posting-form
    [postingForm]="postingForm"
    [errorFields]="state.errorFields"
  ></rti-werken-in-een-hotel-posting-form>
  <rti-error-messages-wrapper [errors]="state.errors"> </rti-error-messages-wrapper>
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" [disabled]="state.creating" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button
    variant="primary"
    [disabled]="!formValid"
    [loading]="state.creating"
    (click)="publish()"
  >
    {{ 'rti.common.submit' | translate }}
  </rt-button>
</rt-dialog-footer>
